import classes from "../../../css/modules/projects.module.scss";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchProjects } from "../../../redux/projects";
import { useDispatch } from "react-redux";
import clsx from "clsx";
import { useApiClient } from '../../../components/ApiProvider';

export function Search() {
  const intervalRef = useRef();
  const isMountedRef = useRef(true);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const apiClient = useApiClient();
  const [token, setToken] = useState(null);

  const handleChange = (event) => {
    if (!event || !event.target) return;
    clearTimeout(intervalRef.current);
    const value = event.target.value;
    intervalRef.current = setTimeout(() => {
      if (isMountedRef.current) {
        dispatch(fetchProjects({ value, token }));
      }
    }, 500);
  };
  const onLeyUp = (e) => {
    if (e.key === "Enter") {
      clearTimeout(intervalRef.current);
      if (isMountedRef.current) {
        dispatch(fetchProjects({ value: e.target.value, token }));
      }
    }
  };
  useEffect(() => {
    if (dispatch && token) {
      dispatch(fetchProjects({ value: "", token }));
    }   
  }, [dispatch, token]);

  useEffect(() => {
    const retrieveToken = async () => {
      const token = await apiClient.getAccessToken();
      if (isMountedRef.current) {
        setToken(token);
      }
    }
    retrieveToken();
  }, [apiClient]);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
      clearTimeout(intervalRef.current);
    };
  }, []);
  return (
    <div className={classes.searchInputWrap}>
      <input
        className={classes.searchInput}
        onChange={handleChange}
        onKeyUp={onLeyUp}
        placeholder={t("Search projects")}
      />
      <span className={clsx("ico icon-magnifier", classes.icon)} />
    </div>
  );
}
